import { OperationTypeEnum } from "@gtpl/shared-models/common-models";
import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { VariantOperation } from "../variant-operation.entity";
import { SequenceModel } from "./sequence-model";
import { VarientOperationDTO } from "./variant-operation.dto";

export class VariantOperationAdapter {
    convertDtoToEntity(variantId:number,variantCode:string,dtoObj: SequenceModel,  isUpdate: boolean = false ): VariantOperation {
        try {
            const entityObj = new VariantOperation();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.unitId = dtoObj.unitId;
            entityObj.variantId = variantId;
            entityObj.variantCode = variantCode;
            entityObj.sequence =dtoObj.sequence;
            entityObj.operationName =dtoObj.operationName;
            entityObj.operationId =dtoObj.operationId;
            entityObj.operationGroup = dtoObj.operationGroup;
            entityObj.groupDependency = dtoObj.groupDependency;
            entityObj.operationDependency = dtoObj.operationDependency;
            entityObj.lossOrGainPercentage = dtoObj.lossOrGainPercentage;
            if(dtoObj.operationCategory){
                entityObj.operationCategory = OperationTypeEnum.VALUE_ADDITION;
            }

            if (dtoObj.VarientOperationId) {
                entityObj.VarientOperationId = dtoObj.VarientOperationId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    // public convertEntityToDto(inputObj: VariantOperation): VarientOperationDTO {
    //     const varientOperationDto= new VarientOperationDTO;
    //     varientOperationDto.VarientOperationId = inputObj.VarientOperationId;
    //     varientOperationDto.variantId = inputObj.variantId;
    //     varientOperationDto.variantCode = inputObj.variantCode;
    //     varientOperationDto.sequenceData=inputObj.;
    //     varientOperationDto.operationGroup = inputObj.operationGroup;
    //     varientOperationDto.groupDependency = inputObj.groupDependency;
    //     varientOperationDto.operationDependency = inputObj.operationDependency;
    //     varientOperationDto.lossOrGainPercentage = inputObj.lossOrGainPercentage;
    //     varientOperationDto.isActive = inputObj.isActive;
    //     varientOperationDto.createdAt = inputObj.createdAt;
    //     varientOperationDto.updatedAt = inputObj.updatedAt;
    //     varientOperationDto.createdUser = inputObj.createdUser;
    //     varientOperationDto.updatedUser = inputObj.updatedUser;
    //     varientOperationDto.versionFlag = inputObj.versionFlag;
    //     return varientOperationDto;
    //   }
}